module.exports = __webpack_public_path__ + "img/iconDecolaSmall.d642f8c4.svg";